import { useEffect } from "react";
import { useQuery } from "@apollo/client/react";
import { useWorkspaceFeatureFlags } from "src/contexts/global/WorkspaceContext";
import { getFilterItems, getTagFilterItems } from "./sidebar.graphql";
import { useSidebarContext, ACTIONS } from "./context";

const useSidebarDataQuery = (filters, shouldGetFilters) => {
  const { peopleTagTypesFilter } = useWorkspaceFeatureFlags();

  const [
    {
      query: { isLoaded, variables },
    },
    dispatch,
  ] = useSidebarContext();

  const { searchTermsKey } = variables;
  const isSearching = isLoaded && !!searchTermsKey;
  const isSearchingPersonTags = searchTermsKey === "personTags";

  const { personTags, personTagTypes, ...otherFilters } = filters;

  const filterSkip =
    !shouldGetFilters || (isSearching && isSearchingPersonTags);
  const {
    data: filterData,
    loading: filterLoading,
    error: filterError,
  } = useQuery(getFilterItems, {
    variables: {
      ...variables,
      filter: otherFilters,
    },
    fetchPolicy: "cache-first",
    skip: filterSkip,
  });

  useEffect(() => {
    if (filterSkip || filterLoading) return;
    if (filterError) {
      dispatch({ type: ACTIONS.QUERY_ERROR, error: filterError });
      return;
    }
    if (!filterData) return;
    dispatch({
      type: ACTIONS.QUERY_COMPLETE,
      data: filterData,
    });
  }, [filterSkip, filterLoading, filterError, filterData, dispatch]);

  const tagSkip =
    !peopleTagTypesFilter ||
    !shouldGetFilters ||
    (isSearching && !isSearchingPersonTags);
  const {
    data: tagFilterData,
    loading: tagFilterLoading,
    error: tagFilterError,
  } = useQuery(getTagFilterItems, {
    variables: {
      ...variables,
      filter: { personTags, personTagTypes },
    },
    fetchPolicy: "cache-first",
    skip: tagSkip,
  });

  useEffect(() => {
    if (tagSkip || tagFilterLoading) return;
    if (tagFilterError) {
      dispatch({ type: ACTIONS.QUERY_ERROR, error: tagFilterError });
      return;
    }
    if (!tagFilterData) return;
    dispatch({
      type: ACTIONS.TAGS_QUERY_COMPLETE,
      data: tagFilterData,
    });
  }, [tagSkip, tagFilterLoading, tagFilterError, tagFilterData, dispatch]);

  return null;
};

export default useSidebarDataQuery;
